var map = {
	"./OggYoutubeThumbnail.png": 988,
	"./TheAgents.png": 9814,
	"./TheCritic.png": 9404,
	"./TheCritic160x160.png": 1169,
	"./TheCritic32x32.png": 7837,
	"./TheCritic83x83.png": 2818,
	"./TheRater.png": 8351,
	"./TheRater32x32.png": 7460,
	"./TheRater83x83.png": 7511,
	"./TheScribe.png": 5017,
	"./TheScribe160x160.png": 7182,
	"./TheScribe83x83.png": 7340,
	"./TheSherpa.png": 2278,
	"./TheSherpa160x160.png": 8582,
	"./TheSherpa32x32.png": 721,
	"./TheSherpa83x83.png": 507,
	"./TheWriter.png": 8760,
	"./TheWriter160x160.png": 2167,
	"./TheWriter32x32.png": 8766,
	"./TheWriter83x83.png": 7962,
	"./ado-icon.png": 7040,
	"./archive/nothing.txt": 5303,
	"./feature-icon.png": 6723,
	"./jira-icon.png": 9570,
	"./loading-brain.png": 7476,
	"./logo.png": 2620,
	"./no-results.png": 9638,
	"./user-story-icon.png": 6859,
	"./webogg-hint.png": 5547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5248;